<template>
  <div class="my-3 py-2 container-fluid">
    <button
      v-if="lastSeason"
      @click="showCreateForm"
      class="mb-3 btn btn-sm btn-outline-success"
    >
      {{ $t("courses.createCourse") }}
    </button>
    <div class="row">
      <transition name="slide-fade" class="my-4">
        <form-create-course
          v-if="isCreateCourseVisible"
          @formSubmitted="courseCreated"
        />
      </transition>
      <div class="col-12">
        <course-list
          :courses="courses"
          :lastSeason="lastSeason"
          :isEditFormVisible="isEditFormVisible"
          @close-edit-course="getCourses"
          @close-create-form="hideChild"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CourseList from "./components/CourseList";
import FormCreateCourse from "@/components/FormCreateCourse";

export default {
  name: "courses",
  components: {
    CourseList,
    FormCreateCourse,
  },
  data() {
    return {
      courses: [],
      isCreateCourseVisible: false,
      isEditFormVisible: false,
      lastSeason: false,
    };
  },
  created() {
    this.getCourses();
  },
  methods: {
    async getCourses() {
      let response = await axios.get("/courses");
      const courses = response.data.courses;
      this.courses = courses;
      this.lastSeason = response.data.last_season;
    },
    showCreateForm() {
      this.isCreateCourseVisible = true;
      this.isEditFormVisible = false;
    },
    hideChild() {
      this.isCreateCourseVisible = false;
      this.isEditFormVisible = true;
    },
    courseCreated() {
      this.isCreateCourseVisible = false;
      this.getCourses();
    },
  },
};
</script>
